export const SORT_PRODUCTS = 'SORT_PRODUCTS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const BUY_ITEMS = 'BUY_ITEMS';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';



// WEBPACK FOOTER //
// ./src/store/actionTypes.js